export const validateEmail = (value) => {
    if (!value || value.trim() === "") return false;
    if (/\s/.test(value)) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return false;
    return true;
};